import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Image } from '../Image/Image';

// styles
import './case-mobile-website-view.scss';

class CaseMobileWebsiteView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      videoUrl1: this.props.firstVideo,
      videoUrl1Mobile: this.props.firstVideoMobile,
      videoUrl2: this.props.secondVideo,
      videoUrl2Mobile: this.props.secondVideoMobile
    };
  }

  render() {
    if (this.props.backgroundImage === null) {
      return false;
    }

    const firstPosterUrl = `${this.props.firstImage}?w=700&q=75`;
    const secondPosterUrl = `${this.props.secondImage}?w=500&q=75`;

    return (
      <div className="case-mobile-website-view">
        <div
          className="case-mobile-website-view__background-container"
        >
          <Image
            className="case-mobile-website-view__background-image-desktop"
            fluid={this.props.backgroundImage}
          />
          <div className="case-mobile-website-view__content-wrapper-desktop">
            <video
              className="case-mobile-website-view__first-image"
              muted
              loop
              autoPlay
              playsInline
              poster={firstPosterUrl}
            >
              <source src={this.state.videoUrl1} type="video/mp4" />
              <source src={this.state.videoUrl1} type="video/ogg" />
              Your browser does not support the video tag.
            </video>

            <video
              className="case-mobile-website-view__second-image"
              muted
              loop
              autoPlay
              playsInline
              poster={secondPosterUrl}
            >
              <source src={this.state.videoUrl2} type="video/mp4" />
              <source src={this.state.videoUrl2} type="video/ogg" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="case-mobile-website-view__content-wrapper-mobile">
            <video
              className="case-mobile-website-view__first-image"
              muted
              loop
              autoPlay
              playsInline
              poster={this.props.firstImage}
            >
              <source src={this.state.videoUrl1Mobile} type="video/mp4" />
              <source src={this.state.videoUrl1Mobile} type="video/ogg" />
              Your browser does not support the video tag.
            </video>

            <video
              className="case-mobile-website-view__second-image"
              muted
              loop
              autoPlay
              playsInline
              poster={this.props.secondImage}
            >
              <source src={this.state.videoUrl2Mobile} type="video/mp4" />
              <source src={this.state.videoUrl2Mobile} type="video/ogg" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    );
  }
}

export default CaseMobileWebsiteView;

CaseMobileWebsiteView.defaultProps = {
  backgroundImage: {},
  firstImage: '',
  secondImage: ''
};

CaseMobileWebsiteView.propTypes = {
  backgroundImage: PropTypes.object,
  firstImage: PropTypes.string,
  secondImage: PropTypes.string
};
